import getSystemInfoToWeb from "./web/getSystemInfo";
var getSystemInfo = getSystemInfoToWeb;
export { getSystemInfo };